export default {
  'controlledDisbursements.1stPresAmount': '1st Presentment Amount',
  'controlledDisbursements.1stPresCount': '1st Presentment Count',
  'controlledDisbursements.1stPresStatus': '1st Presentment Status',
  'controlledDisbursements.2ndPresAmount': '2nd Presentment Amount',
  'controlledDisbursements.2ndPresCount': '2nd Presentment Count',
  'controlledDisbursements.allAccounts': 'All accounts selected',
  'controlledDisbursements.2ndPresStatus': '2nd Presentment Status',
  'controlledDisbursements.presentmentDate': 'Presentment Date',
  'controlledDisbursements.accountTotals': 'Account Totals',
  'controlledDisbursements.selectAccount': 'Select Account',
  'controlledDisbursements.selectedAccounts': '<%=number %> Accounts Selected',
  'controlledDisbursements.title': 'Controlled Disbursement',
  'controlledDisbursements.unmaskAccounts': 'Unmask Accounts',
  'controlledDisbursements.yourRequestCannotBeCompleted':
    'Your request cannot be completed. Please try again'
};
